import { Col, Divider, Input, Row } from "antd";
import rating from "../../assets/icons/smiles/rating.svg";
import bad from "../../assets/icons/smiles/bad.svg";
import notbad from "../../assets/icons/smiles/notbad.svg";
import good from "../../assets/icons/smiles/good.svg";
import ModalComponent from "../../biblio/Modal/ModalComponent";
import PrimaryButton from "../../biblio/Buttons/PrimaryButton";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { toAddRating } from "../../apis/actions/moyasar.actions";
import { showNotitfication } from "../utils/utils";
import { setRatingVisible } from "../../apis/slices/ratingSlice";

interface Props {
  res_id: number;
  isOpe: boolean;
  setIsOpen: (open: boolean) => void;
}
const Rating = ({ res_id, isOpe, setIsOpen }: Props) => {
  const { TextArea } = Input;

  const dispatch = useDispatch<AppDispatch>();

  const isOpen = useSelector((state: RootState) => state?.rating?.isOpen);
  const res_model = useSelector((state: RootState) => state?.rating?.res_model);
  const res_ids = useSelector((state: RootState) => state?.rating?.res_ids);
  const rated_partner_id = useSelector(
    (state: RootState) => state?.rating?.rated_partner_id
  );
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);
  const [activeItem, setActiveItem] = useState<number>(-1);
  const [reason, setReason] = useState<string>("");

  useEffect(() => {
    setIsButtonDisabled(
      activeItem === -1 || (activeItem === 1 && reason === "")
    );
  }, [activeItem, reason]);
  const addRating = async () => {
    const json: any = {
      rating: activeItem,
      res_model: res_model,
      res_ids: res_ids,
    };
    if (activeItem === 1) json.feedback = reason;
    const partnerId = rated_partner_id || (OtpId !== -1 ? OtpId : "");
    if (partnerId) {
      json.rated_partner_id = partnerId;
    }

    const res = await toAddRating(json);
    // eslint-disable-next-line eqeqeq
    if (res.result?.code == 200) {
      setReason("");
      setActiveItem(-1);
      dispatch(setRatingVisible(false));
      setIsOpen(false);
      showNotitfication(res.result?.message, "success");
    } else {
      showNotitfication(res.result?.failure, "error");
    }
  };
  return (
    <ModalComponent
      open={isOpen}
      title=""
      showCloseIcon={true}
      onClose={() => dispatch(setRatingVisible(false))}
      closeOnOutsideClick
    >
      <div
        className="takaful--share-cases-container"
        style={{ marginTop: "0.5rem" }}
      >
        <div className="takaful--share-cases-title-grand">
          <img width={40} src={rating} alt="takaful" />
          <span> تقييم الخدمة</span>
        </div>
      </div>

      <Divider className="takaful--divider-method-payment" />

      <Row dir="rtl">
        <Col
          className="takaful--rating-item"
          span={8}
          onClick={() => setActiveItem(5)}
          style={{
            backgroundColor: activeItem === 5 ? "#f0f0f0" : "transparent",
          }}
        >
          <div>
            <img width={80} src={good} alt="" />
          </div>
          <p className="takaful--rating-good">راضي تماماً</p>
        </Col>
        <Col
          className="takaful--rating-item"
          span={8}
          onClick={() => setActiveItem(3)}
          style={{
            backgroundColor: activeItem === 3 ? "#f0f0f0" : "transparent",
          }}
        >
          <div>
            <img width={80} src={notbad} alt="" />
          </div>
          <p className="takaful--rating-notbad">راضي نوعاً ما</p>
        </Col>
        <Col
          className="takaful--rating-item"
          span={8}
          onClick={() => setActiveItem(1)}
          style={{
            backgroundColor: activeItem === 1 ? "#f0f0f0" : "transparent",
          }}
        >
          <div>
            <img width={80} src={bad} alt="" />
          </div>
          <p className="takaful--rating-bad">غير راضي</p>
        </Col>
      </Row>
      {activeItem === 1 && (
        <div
          dir="rtl"
          style={{ padding: "1rem", marginTop: "1rem", width: "100%" }}
        >
          <p className="takaful--rating-label">سبب عدم الرضا</p>
          <TextArea
            className="takaful--suggestions-complaints-textarea takaful--contact-us-form-inputs"
            rows={4}
            placeholder="فضلاً اكتب سبب عدم رضاك عن الخدمة"
            onChange={(e) => setReason(e.target.value)}
          />
        </div>
      )}
      <PrimaryButton
        style={{ marginTop: "2rem" }}
        className={`${
          isButtonDisabled ? "takaful--inactive" : "takaful--btn-color"
        }`}
        title="إرسال "
        disabled={isButtonDisabled}
        onClick={addRating}
      />
    </ModalComponent>
  );
};

export default Rating;
